import React, {Component} from "react";
import FormatMessage from "../messages/FormatMessage";
import {popupWin} from "../assets-static/scripts/utils";

class EQFooter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<div className="SiteFooter">
            <div className="SiteFooter-layout">
                <div className="FooterLinks SiteFooter-links">
                    <FormatMessage id="applicationcenter.footer.privacy">
                        {(message) => !message.toString().includes("applicationcenter.footer.privacy") ?
                            <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#" onClick={() => popupWin("/privacy-policy")}>
                                    {message}
                                </a>
                            </div> : ""}
                    </FormatMessage>
                    <FormatMessage id="applicationcenter.footer.termsofuse">
                        {(message) => !message.toString().includes("applicationcenter.footer.termsofuse") ?
                            <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#" onClick={() => popupWin("/terms-of-use")}>
                                    {message}
                                </a>
                            </div> : ""}
                    </FormatMessage>
                    <FormatMessage id="applicationcenter.footer.refund.policy">
                        {(message) => !message.toString().includes("applicationcenter.footer.refund.policy") ?
                    <div className="FooterLinks-item">
                                <a className="FooterLinks-link" href="#"
                                   onClick={() => popupWin("/terms-of-use/#" + message + "")}>
                                    <FormatMessage id="applicationcenter.footer.refund"/>
                                </a>
                    </div>: ""}
                    </FormatMessage>
                </div>
                <div className="SiteFooter-legalContainer">
                    <div className="SiteFooter-legalOptional">
                        <div className="RawHTML">
                            <p>
                                <span className="SiteFooter-disclaimerTitle">
                                    <FormatMessage id="application.disclaimer.eq.title">
                                        {(message) => !message.toString().includes("application.disclaimer.eq.title") ? message : ""}
                                    </FormatMessage>
                                </span>
                                &nbsp;<FormatMessage id="application.disclaimer.eq.text">
                                {(message) => !message.toString().includes("application.disclaimer.eq.text") ? message : ""}
                            </FormatMessage>
                            </p>
                            <p>
                                <FormatMessage id="application.disclaimer.eq.subtext">
                                    {(message) => !message.toString().includes("application.disclaimer.eq.subtext") ? message : ""}
                                </FormatMessage>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="SiteFooter-copyright">
                    <FormatMessage id="application.disclaimer.eq.copyright"/>
                </div>
            </div>
        </div>)
    }
}

export default EQFooter
